/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Demo_EyebrowInputs */

const en_funnel_ob_demo_eyebrow = /** @type {(inputs: Funnel_Ob_Demo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's the magic`)
};

const es_funnel_ob_demo_eyebrow = /** @type {(inputs: Funnel_Ob_Demo_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aquí está la magia`)
};

/**
* | output |
* | --- |
* | "Here's the magic" |
*
* @param {Funnel_Ob_Demo_EyebrowInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_demo_eyebrow = /** @type {((inputs?: Funnel_Ob_Demo_EyebrowInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Demo_EyebrowInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_demo_eyebrow(inputs)
	return en_funnel_ob_demo_eyebrow(inputs)
});